<template>
  <div class="preloader" v-if="loading">
    <div class="loader">
      
      <!-- Logo Animada -->
      <img src="/img/logo.png" class="logo" alt="Logo">

      <!-- Mensagem dinâmica -->
      <div class="message">
        <span>{{ currentMessage }}</span>
      </div>

      <!-- Barra de progresso -->
      <div class="progress-container">
        <div class="progress-bar" :style="{ width: progress + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preloader',
  data() {
    return {
      loading: true,
      progress: 0,
      messages: [
        'Carregando sua experiência...',
        'Otimizando performance...',
        'Preparando conteúdo...',
        'Quase pronto...'
      ],
      currentMessage: '',
      messageIndex: 0
    };
  },
  mounted() {
    this.startLoading();
  },
  methods: {
    startLoading() {
      this.currentMessage = this.messages[this.messageIndex];

      const interval = setInterval(() => {
        this.progress += 1;

        // Troca as mensagens a cada 25% de progresso
        if (this.progress % 25 === 0) {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.currentMessage = this.messages[this.messageIndex];
        }

        // Finaliza o preloader ao atingir 100%
        if (this.progress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            this.loading = false;
          }, 600);
        }
      }, 50);
    }
  }
};
</script>

<style scoped>
/* Tela de fundo branca */
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  z-index: 9999;
  overflow: hidden;
}

/* Container do loader */
.loader {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

/* Logo animada */
.logo {
  width: 120px;
  animation: fadeIn 1s ease-in-out, pulse 1.5s infinite ease-in-out;
  margin-bottom: 15px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Mensagem de carregamento */
.message {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 15px 0;
}

/* Barra de progresso */
.progress-container {
  width: 250px;
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 10px;
}

.progress-bar {
  width: 0;
  height: 10px;
  background: linear-gradient(90deg, #3498db, #2563eb);
  transition: width 0.4s ease-in-out;
}
</style>
